import Component from "./Step3";
export default Component;
